import app from './app';
import users from './users';
import { QUOTE_SERVICE_URL, ORDER_SERVICE_URL, DEAL_SERVICE_URL, USERPROFILE_SERVICE_URL, CATALOG_SERVICE_URL, CUSTOMERENTITY_SERVICE_URL } from '../../libs/constants';
import { saveAs } from 'file-saver';
import { getCountriesByRegions } from '../../utils/utility';
//GET LEGALENTITY NAME
const getLegalEntityName = (userId, selectedUserData) => async (dispatch, getState, api) => {
    try {
        dispatch(app.setLoading(true));
        const response = await api.post(`customer/getLegalEntity/${userId}/${selectedUserData.legalEntityId}`);
        dispatch(users.setSelectedUserData({ ...selectedUserData, legalEntityId: response.data.legalEntityName }));
        dispatch(app.setLoading(false));
    } catch (error) {
        dispatch(app.setLoading(false));
        dispatch(app.setAppModal({ type: "error", messageId: "service_error", messageText: error?.response?.data?.message || '' }));
    }
};

// export const getLegalEntities = userId => async (dispatch, getState, api) => {
//     dispatch(app.setLoading(true));
//     const headerConfig = {
//         headers: {
//             "DRS-Fetch-Type": "getLegalEntities"
//         }
//     };

//     await api.post(USERPROFILE_SERVICE_URL + "users/country/legalEntity/" + userId, {}, headerConfig)
//         .then(response => {
//             if (response.data.countryLegalEntityList) {
//                 dispatch(updateDirectCheckoutField({
//                     name: "countryLegalEntityList", value: response.data.countryLegalEntityList
//                 }))
//             }
//             else {
//                 dispatch(app.setAppModal({ type: "error", messageId: "service_error" }));
//             }
//             dispatch(app.setLoading(false));
//         })
//         .catch(error => {
//             dispatch(app.setLoading(false));
//             dispatch(app.setAppModal({ type: "error", messageId: "service_error" }));
//             console.log(error);
//         });
// };

const getLegalEntities = (userId, orgId, selectedLegalEntities, getlegalEntity, userType, userProfile) => async (dispatch, getState, api) => {
    try {
        dispatch(app.setLoading(true));

        const headerConfig = { headers: { "DRS-Fetch-Type": "getCustomerLegalEntities" } };
        const response = await api.post(`${CUSTOMERENTITY_SERVICE_URL}/getCustomerLegalEntities/${userId}/${orgId}`, {}, headerConfig);
        let countryLegalEntityList = {};
        const selectedLegalEntity = response.data.legalEntityList.map(legalEntities => legalEntities).filter(entity => entity.legalEntityName === getlegalEntity || entity.legalEntityId === getlegalEntity);
        if (userType === "legal_entity") {
            if (selectedLegalEntity) {
                (countryLegalEntityList[selectedLegalEntity[0].legalCountry]) ?
                    countryLegalEntityList[selectedLegalEntity[0].legalCountry] = [...countryLegalEntityList[selectedLegalEntity[0].legalCountry], selectedLegalEntity[0].legalEntityName]
                    : countryLegalEntityList[selectedLegalEntity[0].legalCountry] = [selectedLegalEntity[0].legalEntityName];
            }
        }
        else if (userType === "regional") {
            selectedLegalEntities.forEach(legalEntity => {
                response.data.legalEntityList.forEach(entity => {
                    const countries = userProfile?.visibleCountries.length ? userProfile.visibleCountries : getCountriesByRegions(userProfile.visibleRegions);
                    const isCountryVisible = countries.find(country => country === entity.legalCountry);
                    if (legalEntity.legalEntityId === entity.legalEntityId && isCountryVisible) {
                        (countryLegalEntityList[entity.legalCountry]) ?
                            countryLegalEntityList[entity.legalCountry] = [...countryLegalEntityList[entity.legalCountry], entity.legalEntityName]
                            : countryLegalEntityList[entity.legalCountry] = [entity.legalEntityName];
                    }
                });
            });
        }
        else {
            selectedLegalEntities.forEach(legalEntity => {
                response.data.legalEntityList.forEach(entity => {
                    if (legalEntity.legalEntityId === entity.legalEntityId) {
                        (countryLegalEntityList[entity.legalCountry]) ?
                            countryLegalEntityList[entity.legalCountry] = [...countryLegalEntityList[entity.legalCountry], entity.legalEntityName]
                            : countryLegalEntityList[entity.legalCountry] = [entity.legalEntityName];
                    }
                });
            });
        }
        dispatch(updateDirectCheckoutField({
            name: "countryLegalEntityList", value: countryLegalEntityList
        }))
        dispatch(app.setLoading(false));
        dispatch({ type: "SET_CUSTOMER_ENTITY_DETAILS", data: response.data });
    } catch (error) {
        dispatch(app.setLoading(false));
        dispatch(app.setAppModal({ type: "error", messageId: "service_error", messageText: error?.response?.data?.message || '' }));
    }
};


const downloadExcel = (userId) => async (dispatch, getState, api) => {
    try {
        dispatch(app.setLoading(true));
        let downloadConfig = {
            headers: {
                accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel",
                "DRS-Fetch-Type": "downloadHPTemplate"
            },
            responseType: "blob"
        };
        await api.post(QUOTE_SERVICE_URL + `/download/customerFormTemplate/${userId}`, null, downloadConfig)
            .then(response => {
                dispatch(app.setLoading(false));
                saveAs(new Blob([response.data]), "CollectionRequestForm.xlsx");
            })
            .catch(error => {
                dispatch(app.setLoading(false));
            });
    } catch (error) {
        dispatch(app.setLoading(false));
    }
};

const downloadInstructions = (userId) => async (dispatch, getState, api) => {
    dispatch(app.setLoading(true));
    let downloadConfig = {
        headers: {
            accept: "application/pdf"
        },
        responseType: "blob"
    };
    await api.post(QUOTE_SERVICE_URL + `/fetch/excelInstruction/${userId}`, null, downloadConfig)
        .then(response => {
            dispatch(app.setLoading(false));
            const blob = new Blob([response.data], { type: "application/pdf" });
            const url = URL.createObjectURL(blob);
            dispatch(updateDirectCheckoutField({
                name: "pdfURL", value: url
            }));
        })
        .catch(error => {
            console.log(error);
        });
};

const sendRequest = (requestData, checkoutOption = 'STANDARD', successHandler) => async (dispatch, getState, api) => {
    try {
        dispatch(app.setLoading(true));

        const headerConfig = { headers: { "DRS-Fetch-Type": checkoutOption === 'STANDARD' ? "createQuote" : "createOrder" } };
        const url = checkoutOption === 'STANDARD' || (checkoutOption === 'EXCEPTIONAL' && requestData.hasExceptionalQuote) ? QUOTE_SERVICE_URL + '/directCustomer/createQuote' : ORDER_SERVICE_URL + '/directCustomer/createOrder';
        if (checkoutOption === 'EXCEPTIONAL') {
            requestData.checkoutOption = 'EXCEPTIONAL'
        }
        const response = await api.post(url, requestData, headerConfig);

        if (checkoutOption === 'STANDARD' && response && response.data && response.data.quoteId && successHandler) {
            successHandler(response.data.quoteId);
        }
        else if (checkoutOption === 'EXCEPTIONAL' && requestData.hasExceptionalQuote && response && response.data && response.data.quoteId && successHandler) {
            successHandler(response.data.quoteId);
        }
        else if (checkoutOption === 'EXCEPTIONAL' && response && response.data && response.data.orderId && successHandler) {
            successHandler(response.data.orderId);
        }

        dispatch(app.setLoading(false));
    } catch (error) {
        console.log(error);
        dispatch(app.setLoading(false));
        dispatch(app.setAppModal({ type: "error", messageId: "service_error", messageText: error?.response?.data?.message || '' }));
    }
};

const uploadCustomerFormFile = (requestData, userId, countryList, initialQuoteType, ctDirectCustQuotation) => async (dispatch, getState, api) => {
    dispatch(app.setLoading(true));
    const config = {
        headers: {
            'content-type': 'multipart/form-data',
            'countryList': countryList.join(","),
            'ctInitialQuoteType': "DRS",
            "DRS-Fetch-Type": "uploadHPTemplate",
            "ctDirectCustQuotation": ctDirectCustQuotation
        }
    }

    await api.post(QUOTE_SERVICE_URL + "/file/upload/" + userId, requestData, config)
        .then(response => {
            //;
            if (response.data.quoteId) {
                dispatch(updateDirectCheckoutField({
                    name: "quoteId", value: response.data.quoteId
                }));
                dispatch(updateDirectCheckoutField({
                    name: "fileUploadStatus", value: "success"
                }));
                dispatch(updateDirectCheckoutField({
                    name: "fileUploadStatusDesc", value: ''
                }));
            }
            else {
                dispatch(updateDirectCheckoutField({
                    name: "quoteId", value: ""
                }));
                dispatch(updateDirectCheckoutField({
                    name: "fileUploadStatus", value: "error"
                }));
            }
            dispatch(app.setLoading(false));
        })
        .catch(error => {
            console.log(error)
            let quoteId = "";
            try {
                if (error?.response?.data?.traceId && error.response.data.traceId.trim().startsWith("{")) {
                    const parsedData = JSON.parse(error.response.data.traceId);
                    quoteId = parsedData.quoteId;
                }
            } catch (e) {
                quoteId = "";
            }
            dispatch(updateDirectCheckoutField({
                name: "quoteId", value: quoteId || ""
            }));
            dispatch(updateDirectCheckoutField({
                name: "fileUploadStatus", value: "error"
            }));
            dispatch(updateDirectCheckoutField({
                name: "fileUploadStatusDesc", value: error?.response?.data?.message || ''
            }));
            dispatch(app.setLoading(false));
        });
}

const checkActiveDeal = (userId) => async (dispatch, getState, api) => {
    const headerConfig = {
        headers: {
            "DRS-Fetch-Type": "checkActiveDeal"
        }
    };
    dispatch(app.setLoading(true));
    await api.post(QUOTE_SERVICE_URL + '/deal/check/' + userId, {}, headerConfig)
        .then(response => {
            dispatch(app.setLoading(false));
            if (response.data) {
                dispatch(updateDirectCheckoutField({
                    name: "activeDeal", value: response.data.activeDeal
                }))
            }
            else {
                dispatch(updateDirectCheckoutField({
                    name: "activeDeal", value: false
                }))
            }
        })
        .catch(error => {
            dispatch(app.setLoading(false));
            dispatch(updateDirectCheckoutField({
                name: "activeDeal", value: false
            }))
        });
};

export const getAssets = userId => async (dispatch, getState, api) => {
    dispatch(app.setLoading(true));
    const headerConfig = {
        headers: {
            "DRS-Fetch-Type": "getAssets"
        }
    };

    await api.post(CATALOG_SERVICE_URL + "asset/list/" + userId, {}, headerConfig)
        .then(response => {
            if (response.data.assets) {
                dispatch(updateDirectCheckoutField({
                    name: "assets", value: response.data.assets
                }))
            }
            else {
                dispatch(app.setAppModal({ type: "error", messageId: "service_error" }));
            }
            dispatch(app.setLoading(false));
        })
        .catch(error => {
            dispatch(app.setLoading(false));
            dispatch(app.setAppModal({ type: "error", messageId: "service_error", messageText: error?.response?.data?.message || '' }));
            console.log(error);
        });
};

const updateDirectCheckoutField = fieldData => {
    return {
        type: 'UPDATE_DIRECT_CHECKOUT_FIELD',
        data: fieldData
    }
}

const updateDirectCheckoutOrderField = fieldData => {
    return {
        type: 'UPDATE_DIRECT_CHECKOUT_ORDER_FIELD',
        data: fieldData
    }
}

const updateDirectCheckoutCTOrderField = fieldData => {
    return {
        type: 'UPDATE_DIRECT_CHECKOUT_CT_ORDER_FIELD',
        data: fieldData
    }
}

const updateAddressData = (addressData, resetAddressId = false) => {
    return {
        type: 'UPDATE_DIRECT_CHECKOUT_ADDRESS_DATA',
        data: addressData,
        resetAddressId
    }
}

const updateAddressFormField = fieldData => {
    return {
        type: 'UPDATE_DIRECT_CHECKOUT_ADDRESS_FORM_FIELD',
        data: fieldData
    }
}

const setAlternativeContactSwitchCheckbox = switcherState => {
    return {
        type: 'SET_ALTERNATE_CONTACT_SWITCH_CHECKBOX',
        data: switcherState
    }
}

const updateContactData = (contactData, resetContactId = false) => {
    return {
        type: 'UPDATE_DIRECT_CHECKOUT_CONTACT_DATA',
        data: contactData,
        resetContactId
    }
}

const updateContactFormField = fieldData => {
    return {
        type: 'UPDATE_DIRECT_CHECKOUT_CONTACT_FORM_FIELD',
        data: fieldData
    }
}

const setAddtionalComments = data => {
    return {
        type: 'UPDATE_ADDITIONAL_COMMENT_DATA',
        data: data
    }
}

const reset = () => {
    return {
        type: 'RESET_DIRECT_CHECKOUT'
    }
}

const setAssetData = (assetList) => {
    return {
        type: 'SET_ASSET_LIST',
        assetList
    }
}

const setHasExceptionalQuote = switcherState => {
    return {
        type: 'SET_HAS_EXCEPTIONAL_QUOTE',
        data: switcherState
    }
}

const getGradingDescription = () => async (dispatch, getState, api) => {
    const headerConfig = {
        headers: {
            "DRS-Fetch-Type": "getGradingDescription"
        }
    };
    try {
        dispatch(app.setLoading(true));
        const response = await api.get(`${CATALOG_SERVICE_URL}getAppConfiguration/grading_description`, {}, headerConfig);
        dispatch({ type: "SET_GRADING_DESCRIPTION", data: response.data.configMapValueList });
        dispatch(app.setLoading(false));
    } catch (error) {
        dispatch(app.setLoading(false));
        dispatch(app.setAppModal({ type: "error", messageId: "service_error", messageText: error?.response?.data?.message || '' }));
    }
};

const getActiveDeal = (userId, orgId) => async (dispatch, getState, api) => {
    const headerConfig = {
        headers: {
            "DRS-Fetch-Type": "getActiveDeal"
        }
    };
    try {
        dispatch(app.setLoading(true));
        const response = await api.get(`${QUOTE_SERVICE_URL}${DEAL_SERVICE_URL}/getActiveDealAndEntities/${userId}/${orgId}`, {}, headerConfig);
        dispatch({ type: "SET_DEAL_DETAILS", data: response.data });        
        dispatch(app.setLoading(false));
    } catch (error) {
        dispatch(app.setLoading(false));
        dispatch(app.setAppModal({ type: "error", messageId: "service_error", messageText: error?.response?.data?.message || '' }));
    }
};

const getDirectUserList = (orgId, company) => async (dispatch, getState, api) => {
    const headerConfig = {
        headers: {
            "DRS-Fetch-Type": "getDirectUserList"
        }
    };
    try {
        dispatch(app.setLoading(true));
        const response = await api.get(`${USERPROFILE_SERVICE_URL}usersMailIds/${orgId}/${company}`, {}, headerConfig);
        dispatch({ type: "SET_DIRECT_USER_LIST", data: response.data });
        dispatch(app.setLoading(false));
    } catch (error) {
        dispatch(app.setLoading(false));
        dispatch(app.setAppModal({ type: "error", messageId: "service_error", messageText: error?.response?.data?.message || '' }));
    }
};

const resetActiveDeal = () => {
    return {
        type: 'RESET_DEAL_DETAILS',
        data: {
            dealId: "",
            dealName: "",
            countriesLegalEntities: []
        }
    }
}

const quoteActions = {
    getLegalEntityName,
    getLegalEntities,
    updateDirectCheckoutField,
    updateDirectCheckoutOrderField,
    updateDirectCheckoutCTOrderField,
    updateAddressData,
    updateAddressFormField,
    setAlternativeContactSwitchCheckbox,
    updateContactData,
    updateContactFormField,
    setAddtionalComments,
    downloadExcel,
    downloadInstructions,
    uploadCustomerFormFile,
    sendRequest,
    checkActiveDeal,
    getAssets,
    reset,
    setAssetData,
    setHasExceptionalQuote,
    getGradingDescription,
    getActiveDeal,
    resetActiveDeal,
    getDirectUserList
}

export default quoteActions;